/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { DateRangeSelect } from '../../common/components';

function TableFilter({ handleLoadAgents }) {
  const dispatch = useDispatch();
  const {
    agents: {
      sortTerm,
      sortInverse,
      agencyFilter,
      searchTerm,
      updatedStartDate,
      updatedEndDate,
      isRegisteredFilter,
      accountTypeFilter,
    },
    agencies: { records: agencies },
    theme: {
      features: {
        agentRegistration,
        agentLastUpdateFilter = true,
        agentSearchAgencyFilter,
        agentSearchAccountTypeFilter,
      },
    },
    user: { is_admin: isAdmin },
  } = useSelector(store => store);

  function handleSearch() {
    handleLoadAgents({
      page: 1,
      sort: sortTerm,
      direction: sortInverse,
      agencyFilter,
      searchTerm,
      updatedStartDate,
      updatedEndDate,
      isRegisteredFilter,
      accountTypeFilter,
    });
  }

  function clearFilters() {
    const irf = (agentRegistration ? 'all' : undefined);
    dispatch({ type: 'SET_AGENCY_FILTER', payload: '' });
    dispatch({ type: 'SET_SEARCH_TERM', payload: '' });
    dispatch({
      type: 'SET_AGENTS_FIELDS',
      payload: {
        updatedStartDate: undefined,
        updatedEndDate: undefined,
        isRegisteredFilter: irf,
        accountTypeFilter: '',
      },
    });
    handleLoadAgents({
      page: 1,
      agencyFilter: '',
      searchTerm: '',
      updatedStartDate: '',
      updatedEndDate: '',
      accountTypeFilter: '',
      isRegisteredFilter: irf,
    });
  }

  return (
    <>
      <div className="col-md-3 align-middle ms-4">

        <div className="row mb-1">
          <div className="d-flex col fw-bold">
            Name / Email / NPN:
          </div>
        </div>
        <div className="row">
          <div className="d-flex col">
            <input
              placeholder="Search"
              className="form-control border"
              value={searchTerm}
              onChange={(e) => dispatch({ type: 'SET_SEARCH_TERM', payload: e.target.value })}
              onKeyDown={(e) => {
                if (e.keyCode === 13) handleSearch();
              }}
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="d-flex col">
            &nbsp;
          </div>
        </div>
        <div className="row">
          <div className="d-flex col">
            <button
              type="button"
              className="btn btn-secondary text-white"
              onClick={handleSearch}
            >
              Filter
            </button>
            <button
              type="button"
              className="btn btn-primary text-white ms-3"
              onClick={clearFilters}
            >
              Clear
            </button>
          </div>
        </div>

      </div>

      {agentLastUpdateFilter && (
        <div className="col-md-3 align-middle ms-4">
          <div className="row mb-1">
            <div className="d-flex col fw-bold">
              Last update filter:
            </div>
          </div>
          <div className="row mb-2">
            <div className="d-flex col">
              <DateRangeSelect
                defaultDaysSelection={false}
                startDate={updatedStartDate}
                endDate={updatedEndDate}
                startSetter={(sd) => dispatch({ type: 'SET_AGENTS_FIELDS', payload: { updatedStartDate: sd } })}
                endSetter={(ed) => dispatch({ type: 'SET_AGENTS_FIELDS', payload: { updatedEndDate: ed } })}
              />
            </div>
          </div>
        </div>
      )}

      <div className="col-md-2 align-items-center ms-3">
        {agentSearchAgencyFilter && isAdmin && (
          <>
            <div className="row mb-1">
              <div className="d-flex col fw-bold">
                Agent Group Filter:
              </div>
            </div>
            <div className="row mb-2">
              <div className="d-flex col">
                <select
                  className="form-select"
                  name="agency"
                  id="agency"
                  onChange={(e) => dispatch({ type: 'SET_AGENCY_FILTER', payload: e.target.value })}
                  value={agencyFilter}
                >
                  <option value="">All Agent Groups</option>
                  <option value="_none_">Unassigned</option>
                  {agencies.map((agency) => (
                    <option
                      key={agency.id}
                      value={agency.id}
                    >
                      {agency.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        )}

        {agentRegistration && (
          <>
            <div className="row mb-1">
              <div className="d-flex col fw-bold">
                Registration Status:
              </div>
            </div>
            <div className="row">
              <div className="d-flex col">
                <select
                  className="form-select"
                  name="agency"
                  id="agency"
                  onChange={(e) => dispatch({ type: 'SET_AGENTS_FIELDS', payload: { isRegisteredFilter: e.target.value } })}
                  value={isRegisteredFilter}
                >
                  <option value="all">All Agents</option>
                  <option value="registered">Registered</option>
                  <option value="unregistered">Not Registered</option>
                </select>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="col-md-2 align-items-center ms-3">

        {agentSearchAccountTypeFilter && (
          <>
            <div className="row mb-1">
              <div className="d-flex col fw-bold">
                Account Type;
              </div>
            </div>
            <div className="row">
              <div className="d-flex col">
                <select
                  className="form-select"
                  name="agency"
                  id="agency"
                  onChange={(e) => dispatch({ type: 'SET_AGENTS_FIELDS', payload: { accountTypeFilter: e.target.value } })}
                  value={accountTypeFilter}
                >
                  <option value="">All</option>
                  <option value="is_agent">Agent</option>
                  <option value="is_admin">Admin</option>
                  <option value="is_agency_admin">Agent Group Admin</option>
                </select>
              </div>
            </div>
          </>
        )}

      </div>

    </>
  );
}

export default TableFilter;
